import React, { useMemo, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useSteppedProcess } from '../context';
import { TextHeading } from '../../Typography';
import { StepNumber } from './StepNumber';
import { a11y } from '../strings';
const StepTitleWrapper = styled.div `
  ${({ theme: { space } }) => `
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 0;
    margin: 0 0 ${space.xs} 0;
  `}
`;
const stepHeadingColor = (isStepActive, isStepComplete) => {
    return isStepActive || isStepComplete ? 'slate-5' : 'gray-700';
};
const StepHeading = styled(TextHeading) `
  ${({ isStepActive, isStepComplete, theme: { colors } }) => `
    color: ${colors[stepHeadingColor(isStepActive, isStepComplete)]};
    font-weight: ${isStepActive ? 'bold' : 'normal'};
  `}
`;
const StepTitle = ({ stepIndex, step, getAriaLabelStepTitle = a11y.getAriaLabelStepTitle, }) => {
    const { focusStep, isStepActive, isStepComplete } = useSteppedProcess();
    const titleRef = useRef(null);
    useEffect(() => {
        var _a;
        if (stepIndex === focusStep)
            (_a = titleRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focusStep]);
    const stepStatus = useMemo(() => {
        if (isStepActive(stepIndex))
            return 'Current Step';
        if (isStepComplete(stepIndex))
            return 'Complete';
        return undefined; // future steps return no status
    }, [stepIndex, isStepActive, isStepComplete]);
    const stepActive = useMemo(() => isStepActive(stepIndex), [stepIndex, isStepActive]);
    const stepComplete = useMemo(() => isStepComplete(stepIndex), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [stepIndex, isStepActive]);
    const ariaLabel = useMemo(() => {
        const stepNumber = stepIndex + 1;
        const stepTitle = step.title.text;
        return getAriaLabelStepTitle({
            stepNumber,
            stepTitle,
            isStepActive: !!stepActive,
            isStepComplete: !!stepComplete,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stepIndex, step, stepStatus]);
    return (React.createElement(StepTitleWrapper, null,
        React.createElement(StepNumber, { stepIndex: stepIndex }),
        React.createElement(StepHeading, { ref: titleRef, id: step.title.id, "aria-label": ariaLabel, tag: step.title.headingLevel || 'h2', size: "sm", tabIndex: -1, isStepActive: !!isStepActive(stepIndex), isStepComplete: !!isStepComplete(stepIndex) }, step.title.text)));
};
export { StepTitle };
//# sourceMappingURL=StepTitle.js.map